import {Mapper} from '@s-ui/domain'

export class FromRemoteSeoContentToSeoResponseSeoMapper extends Mapper {
  #seoDataValueObjectFactory

  constructor({seoDataValueObjectFactory}) {
    super()
    this.#seoDataValueObjectFactory = seoDataValueObjectFactory
  }

  map = ({localSeoDataResponse, remoteSeoContent}) => {
    const localSeoData = localSeoDataResponse.toJSON()

    const h1 = remoteSeoContent.h1
    const title = remoteSeoContent.title
    const description = remoteSeoContent.description

    const meta = localSeoData.head.meta.map(tag => {
      if (tag.name === 'description') return {...tag, content: description}
      if (tag.property === 'og:title') return {...tag, content: title}

      if (tag.property === 'og:description') return {...tag, content: description}
      return tag
    })

    return this.#seoDataValueObjectFactory({
      h1,
      staticFallbackH1: localSeoData.h1,
      head: {
        title,
        meta,
        link: localSeoData.head.link,
        scripts: localSeoData.head.scripts
      }
    })
  }
}
